<template>
  <div class="container body">
    <div class="main_container">
      <div class="col-md-12">
        <div class="col-middle">
          <div class="text-center text-center">
            <h1 class="error-number">{{ statusCode }}</h1>
            <h2>{{ title }}</h2>
            <p>{{ message }}</p>
            <router-link :to="{ name: 'home' }" style="color:#fff">
              <font-awesome-icon icon="home" /> {{ $t('common.backToHome') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      statusCode: 500,
      title: 'Internal Server Error',
      message:
        'if the problem persists feel free to contact us. In the meantime, try refreshing.',
    }
  },
  computed: {
    ...mapGetters({
      fetchedCode: 'error/getCode',
      fetchedMessage: 'error/getMessage',
    }),
  },
  mounted() {
    if (
      this.$route.params.code !== undefined &&
      this.$route.params.message !== undefined
    ) {
      this.statusCode = this.$route.params.code
      this.message = this.$route.params.message
      this.$store.dispatch('error/setCode', this.$route.params.code)
      this.$store.dispatch('error/setMessage', this.$route.params.message)
    } else if (
      typeof this.fetchedCode !== 'function' &&
      typeof this.fetchedMessage !== 'function'
    ) {
      this.statusCode = this.fetchedCode
      this.message = this.fetchedMessage
    }

    switch (this.statusCode) {
      case 500:
        this.title = 'Internal Server Error'
        break

      case 501:
        this.title = 'Not Implemented'
        break

      case 502:
        this.title = 'Bad Gateway'
        break

      case 503:
        this.title = 'Service Unavailable'
        break

      case 504:
        this.title = 'Gateway Timeout'
        break

      case 505:
        this.title = 'HTTP Version Not Supported'
        break

      case 506:
        this.title = 'Variant Also Negotiates'
        break

      case 507:
        this.title = 'Insufficient Storage'
        break

      case 508:
        this.title = 'Loop Detected'
        break

      case 509:
        this.title = 'Bandwidth Limit Exceeded'
        break

      case 510:
        this.title = 'Not Extended'
        break

      case 511:
        this.title = 'Network Authentication Required'
        break
    }
  },
}
</script>
